<template lang="pug">
  #ModalConfirmation
    p#title {{title}}
    form#formBody(@submit="submit")
      b-form-group(id="input-group-startDate" label="Fecha de Inicio" label-for="input-startDate")
        b-form-datepicker(id="input-startDate" v-model="startDate" locale="es-CL")
        .errors
          .error(v-if="!$v.startDate.required") Campo requerido
      .modal-footer
        b-button(@click="hideModal" variant="outline-muted") Cancelar
        b-button(variant="success" type="submit")
          font-awesome-icon(icon="check")
          span {{btnText}}
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
export default {
  props: ['selected', 'hideModal', 'title', 'action', 'btnText', 'makeToast', 'defaultStartDate'],
  validations: {
    startDate: { required }
  },
  data() {
    return {
      startDate: this.action === 'activate' ? this.defaultStartDate : this.selected.startDate
    }
  },
  methods: {
    ...mapActions(['createBusinessService', 'editBusinessService']),
    async submit() {
      if (!this.$v.startDate.$invalid) {
        this.selected.active = true;
        this.selected.startDate = this.startDate;
        const action = this.action === 'activate' ? this.createBusinessService : this.editBusinessService;
        const response = await action(this.selected);
        if (response.status === 200 || response.status === 201) {
          this.makeToast("success", response.data.message, "Éxito!");
          this.hideModal();
        } else {
          this.makeToast("danger", response.data, "Ocurrió un error!");
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
#ModalConfirmation{
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
      margin: 0;
  }

  #title {
    font-size: 24px;
    font-weight: 600;
    color: #323338;
  }
  #formBody {
    display: flex;
    flex-direction: column;
    width: 100%;
    #input-group-startDate{
      text-align: left;
    }
    #buttons {
      align-self: flex-end;
      margin: 0 20px 20px 20px;
    }
  }
}
</style>